import { KeyboardService, KEYBOARD_MODES } from './keyboard.service';

export default angular
  .module('sfMobile.services.keyboard', ['sfMobile.services.pubsub'])
  .factory('keyboardService', KeyboardService)
  .constant('KEYBOARD_MODES', KEYBOARD_MODES).name;
